import * as yup from "yup";
import { useMemo } from "react";
import { TextField } from "@mui/material/";
import { mdiLockQuestion } from "@mdi/js";
import { useNavigate } from "react-router-dom";

import AppBar from "components/AppBar";
import AuthForm from "components/AuthForm";
import PageLayout from "components/PageLayout";
import useNotifier from "hooks/useNotifier";
import AuthApi from "api/auth";

const validationSchema = yup.object().shape({
  email: yup.string().trim().required("Email address is required").email("Email address is not valid"),
});

function ForgotPassword() {
  const navigate = useNavigate();
  const { showNotification } = useNotifier();
  const authApi = useMemo(() => new AuthApi(showNotification), [showNotification]);

  async function sendPasswordResetEmail(data: { email: string }) {
    const { error } = await authApi.sendResetPasswordEmail(data.email);

    if (!error) {
      navigate("/");
    }
  }

  return (
    <PageLayout appBar={<AppBar backAction={false} noRadius showLogo title='GroupUp' />}>
      <AuthForm<ForgotPasswordForm>
        avatarIcon={mdiLockQuestion}
        links={[{ label: "Remembered you password ? Sign In", href: "/" }]}
        submitLabel='Send password reset email'
        title='Forgot password'
        validationSchema={validationSchema}
        onSubmit={sendPasswordResetEmail}
      >
        <TextField name='email' label='Email address' autoComplete='email' fullWidth autoFocus />
      </AuthForm>
    </PageLayout>
  );
}

export default ForgotPassword;

interface ForgotPasswordForm extends Record<string, unknown> {
  email: string;
}
